<app-modal [id]="modalId" [maskClose]="false">
  <aside class="modal">
    <div class="modal-body">
      <h2>{{_data.header}}</h2>
      @if (form) {
        <form [formGroup]="form" (ngSubmit)="sendMail($event)">
          @if (!finished) {
            <div>
              <p>{{_data.text}}</p>
              <label [innerHtml]="_data.label"></label>
              <div class="inputs">
                <app-form-input [input]="mailForm.name" [form]="form"></app-form-input>
                <app-form-input [input]="mailForm.email" [form]="form"></app-form-input>
                <app-form-input [input]="mailForm.content" [form]="form"></app-form-input>
              </div>
            </div>
          }
          @if (finished) {
            <div class="finish-text">Your inquiry has been sent.</div>
          }
          <div class="buttons">
            @if (finished) {
              <button type="button" class="regular button solid-green" (click)="close()">OK</button>
            }
            @if (!finished) {
              <button type="submit" class="regular button solid-green {{_data.buttonClass}}">
                @if (!loading) {
                  <span>{{_data.button}}</span>
                }
                @if (loading) {
                  <span>Processing...</span>
                }
              </button>
            }
            @if (!finished) {
              <button type="button" class="regular button solid-red {{_data.cancelClass}}" (click)="close()">Cancel</button>
            }
          </div>
        </form>
      }
    </div>
  </aside>
  <div class="modal-background"></div>
</app-modal>
<app-error-modal [modalId]="'mf-error-modal'" [text]="errorText"></app-error-modal>
